import React from 'react'
import SectionTests from '../components/SectionTests/SectionTests'

const Tests = () => {
  return (
    <div>
      <SectionTests />
    </div>
  )
}

export default Tests
